// Override Settings
var boostPFSInstantSearchConfig = {
  search: {
    //suggestionMode: 'test',
    //suggestionPosition: 'left'
    //suggestionMobileStyle: 'style2'
    suggestionMobileStyle: "style1",
  },
};

(function () {
  /* This is to inject boost components into this scope, so we can override component's function */
  BoostPFS.inject(this);

  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function () {};
  window.addEventListener("DOMContentLoaded", (event) => {
    jQ(".header-icon-search")[0].on("click", function () {
      const fakeInput = document.createElement("input");
      const targetInput = jQ('#boost-pfs-search-box-mobile')[0];
      
      fakeInput.setAttribute("type", "text");
      fakeInput.style.position = "absolute";
      fakeInput.style.opacity = 0;
      fakeInput.style.height = 0;
      fakeInput.style.fontSize = "16px"; // disable auto zoom
      // you may need to append to another element depending on the browser's auto
      // zoom/scroll behavior
      document.body.prepend(fakeInput);
      fakeInput.focus();
    
      setTimeout(() => {
          fakeInput.remove();
          targetInput.focus();
      }, 3000)
    });
  });
  jQ('.site-nav__link.site-nav__link--icon.js-search-header.medium-up--hide').on('click', function(event) {
      setTimeout(function() {
      jQ('.boost-pfs-search-box').focus();
      }, 500);
  });

})();
